export default __webpack_public_path__ + "static/title-image-43ba71ab6b535b197bef99b54cce7167.jpg";